// export const LOCAL_ENV = {
//   MOCK_API: false,
// };

export const CONSTS = {
  VER: 'VER',
  ERR: 'ERR',
  OK: 'OK',
};

export const REGEX = {
  PAN: new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/),
  ONLYCHAR: new RegExp(/^[A-Za-z\s]+$/),
  ONLYNUM: new RegExp(/^[0-9]*$/),
  LINKS: new RegExp(
    /^(https?:\/\/)(www\.)?[a-zA-Z0-9@:%._\+~#?&//=]{2,256}\.[a-z]{2,6}\b(\/[-a-zA-Z0-9@:%._\+~#?&//=]*)*$/i
  ),
  EMAIL: new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
  IFSC: new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/), // SBIN0001234
  GST: new RegExp(
    /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z0-9]{3}$|^\d{4}[A-Z]{3}\d{5}[0-9A-Z]{3}$|^\d{2}[A-Z]{4}\d{5}[A-Z][A-Z0-9]{3}$/
  ),
  CIN: new RegExp(
    /^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/
  ),
};

export const TOAST_CONFIG = {
  position: 'top-right',
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  theme: 'colored',
  closeButton: true,
  style: {
    fontSize: '14px',
    top: '1rem',
    right: '1rem',
    minHeight: 'auto',
    margin: '4px 0',
    width: window.innerWidth < 500 ? 'calc(100% - 2rem)' : undefined,
  },
};

// Toast ID constants
export const TOAST_IDS = {
  ERROR: 'error-toast',
  SUCCESS: 'success-toast',
  WARNING: 'warning-toast',
  INFO: 'info-toast',
};